// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityAssignmentController from "./activity_assignment_controller"
application.register("activity-assignment", ActivityAssignmentController)

import ActivityIndexController from "./activity_index_controller"
application.register("activity-index", ActivityIndexController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import DashboardScrollController from "./dashboard_scroll_controller"
application.register("dashboard-scroll", DashboardScrollController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import SlimselectController from "./slimselect_controller"
application.register("slimselect", SlimselectController)
